import {
    AnyAction,
    CaseReducer,
    Draft,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatActionType,
    NinchatLoadHistoryAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatClientPromiseValue,
} from '../NinchatClient'
import {NinchatEventType} from '../types/events'
import {NinchatState} from 'api/types'
import {historyResults} from 'api/event/historyResults'
import {messageReceived} from '../event/messageReceived'

const actionTypePrefix = 'NINCHAT/action'

type MetaReducerAsyncThunkConfig = {fulfilledMeta: {reducer: CaseReducer}}

export const loadHistory = createAsyncThunk<NinchatClientPromiseValue, NinchatActionParams<NinchatLoadHistoryAction>, MetaReducerAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatLoadHistoryAction}`,
    async (arg, thunkAPI) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatLoadHistoryAction

        const meta = {reducer: historyResultsOrMessageReceivedReducer} // eslint-disable-line @typescript-eslint/no-use-before-define

        try {
            const reply = await ninchatClient.send(params)

            return thunkAPI.fulfillWithValue(reply, meta)
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
)

const historyResultsOrMessageReceivedReducer = (state: Draft<NinchatState>, action: AnyAction) => {
    const payloads = Array.isArray(action.payload) ? action.payload : [action.payload]

    for (const p of payloads.slice().reverse()) {
        const payload = typeof p.event === 'object' ? p : {event: p}

        const eventType = payload.event.event

        switch (eventType) {
            case NinchatEventType.NinchatHistoryResultsEvent:
                historyResults(state, action)
                break
            case NinchatEventType.NinchatMessageReceivedEvent:
                messageReceived.reducer(state, {
                    ...action,
                    meta: messageReceived.meta(state, payload),
                    payload,
                })
                break
            default:
        }
    }
}
